import React from 'react';

/**
 * Componente para modal de detalhes
 */
const DetailModal = ({ detailView, setDetailView }) => {
  if (!detailView) return null;

  const getModalTitle = () => {
    switch (detailView.type) {
      case 'sem_mensagem_lead':
        return 'Conversas Sem Mensagem do Lead';
      case 'sem_resposta_atendente':
        return 'Conversas Sem Resposta do Atendente (entre leads que responderam)';
      case 'atendente_respondidas':
        return `${detailView.filter.atendente} - Conversas Respondidas`;
      case 'atendente_nao_respondidas':
        return `${detailView.filter.atendente} - Conversas Não Respondidas`;
      case 'janela_lead':
        return `Janela ${detailView.filter.janela?.nome} - Análise Lead`;
      case 'janela_atendente':
        return `Janela ${detailView.filter.janela?.nome} - Análise Atendente`;
      default:
        return 'Detalhes';
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[80vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">
            {getModalTitle()}
            <span className="text-sm font-normal text-gray-500 ml-2">
              ({detailView.data.length} registros)
            </span>
          </h3>
          <button
            onClick={() => setDetailView(null)}
            className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
          >
            ×
          </button>
        </div>
        
        <div className="p-6 overflow-auto max-h-[60vh]">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data Conversão
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Cliente
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Origem
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Atendente
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Mensagem do Lead
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Resposta do Atendente
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Link
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {detailView.data.slice(0, 100).map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      {item.dataConversao ? 
                        item.dataConversao.toLocaleDateString('pt-BR') + ' ' + 
                        item.dataConversao.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) 
                        : 'N/A'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      <div className="max-w-32 truncate" title={item.nomeCliente}>
                        {item.nomeCliente || 'N/A'}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      <div className="max-w-32 truncate" title={item.origem}>
                        {item.origem || 'N/A'}
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      {(() => {
                        const v = item.atendenteResponsavel || '';
                        if (!v) return 'N/A';
                        const name = v.includes('@') ? v.split('@')[0] : v;
                        return name;
                      })()}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        item.temMensagemLead 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {item.temMensagemLead ? 'Lead enviou mensagem' : 'Lead não enviou mensagem'}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        item.temRespostaAtendente 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {item.temRespostaAtendente ? 'Atendente respondeu' : 'Atendente não respondeu'}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                      {Array.isArray(item.tickets) && item.tickets.length > 0 ? (
                        <div className="space-x-2 flex flex-wrap gap-2">
                          {item.tickets.map((t, idx) => (
                            <a
                              key={`${item.id || idx}-${idx}`}
                              href={t}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-orange-600 hover:text-orange-900 font-medium underline"
                            >
                              Conversa {idx + 1}
                            </a>
                          ))}
                        </div>
                      ) : (
                        item.linkConversa && (
                          <a
                            href={item.linkConversa}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-orange-600 hover:text-orange-900 font-medium"
                          >
                            Ver conversa
                          </a>
                        )
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {detailView.data.length > 100 && (
              <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-md">
                <p className="text-sm text-yellow-800">
                  Mostrando apenas os primeiros 100 registros de {detailView.data.length} total.
                  Use os filtros para refinar a busca.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailModal;
